<template>
  <div>
    <div class="bg-white pt-3 border rounded shadow-sm">
      <div class="font-semibold mx-2 text-gray-600">Connection modes Overview</div>
      <div class=" overflow-auto mt-4 "> 
        <table v-if="!loading" class="table-auto w-full mb-3 ">
          <thead>
          <tr class="border-b font-bold">
            <td class="px-3 py-2"></td>
            <td class="px-3 py-2">Daily</td>
            <td class="px-3 py-2">Weekly</td>
            <td class="px-3 py-2">Monthly</td>
            <td class="px-3 py-2">Annually</td>
            <td class="px-3 py-2">Total</td>
          </tr>
          </thead>
          <tbody>
          <tr class="border-t hover:bg-gray-200" v-for="record in overview" :key="record.mode">
            <td class="px-3 py-2 uppercase">
              {{record.mode}}
            </td>
            <td class="px-3 py-2">{{ Math.round(record.connections / record.days) }}</td>
            <td class="px-3 py-2">{{ Math.round(record.connections / record.weeks) }}</td>
            <td class="px-3 py-2">{{ Math.round(record.connections / record.months) }}</td>
            <td class="px-3 py-2">{{ Math.round(record.connections / record.years) }}</td>
            <td class="px-3 py-2">{{ Math.round(record.connections) }}</td>
          </tr>

          </tbody>
        </table>
        <div v-else class="py-6 text-center w-full">
          <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
          <p>Loading...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import GraphQl from "../../services/graphql.service";

export default {
  name: "ConnectionModeOverviewReport",
  components: {},
  data() {
    return {
      overview: [],
      loading: true
    }
  },
  props: {
    configs: Object
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    configs: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  methods: {
    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },
    // loadStats(newPage) {
    //   this.currentPage = newPage || 1;
    //   this.loading = true
    //   let params = 'endDate: "' + this.configs.endDate + '", startDate: "' + this.configs.startDate + '"';
    //   let query = 'connectionModeOverview(' + params + '){days weeks months years connections mode}'
    //   GraphQl.sendRequest('{' + query + '}')
    //       .then(response => {
    //         this.overview = response.connectionModeOverview;
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       })
    // }
    loadStats(newPage) {
        this.currentPage = newPage || 1;
        this.loading = true
      // let v = [];
      // this.filters.venues.forEach((venue) => {
      //   v.push(venue.id);
      // });

      // let params =
      //   (this.filters.venues.length > 0
      //     ? 'venues:["' + v.join('","') + '"],'
      //     : "") +
      //   'startDate: "' +
      //   moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") +
      //   '", ' +
      //   'endDate: "' +
      //   moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") +
      //   '"';
      let params = 'endDate: "' + this.configs.endDate + '", startDate: "' + this.configs.startDate + '"';

      // Reset chart data
     // this.chartData.labels = [];
     // this.chartData.datasets[0].data = [];
     // this.exportData = [];

      GraphQl.sendRequest(
        "{aggregateAuthModeSummary(" + params + "){mode connections}}"
      ).then((response) => {
        // response.aggregateAuthModeSummary.forEach((stat) => {
        //  // this.chartData.labels.push(stat.mode);
        //  // this.chartData.datasets[0].data.push(stat.connections);
        //   // this.exportData.push({
        //   //   Mode: stat.mode,
        //   //   Connections: stat.connections,
        //   // });
          
        // });
        this.overview = response.connectionModeOverview;
         this.loading = false;
       // this.chart.update();
      });
    }
  }
}
</script>

<style scoped>
</style>